import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-civitas-navy text-white">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <span className="font-display text-lg font-semibold text-white">BECivitas</span>
            <p className="mt-2 text-sm text-civitas-silver">
              Non-partisan voter information for the 2026 General Election — all 50 states.
              Your preferences stay on your device — always.
            </p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-civitas-gold mb-3">Navigate</h4>
            <ul className="space-y-2 text-sm text-civitas-silver">
              {[
                ['/questionnaire', 'Take the Questionnaire'],
                ['/candidates',    'Browse Candidates'],
                ['/results',       'My Matches'],
                ['/compare',       'Compare Candidates'],
                ['/how-it-works',  'How It Works'],
              ].map(([to, label]) => (
                <li key={to}><Link to={to} className="hover:text-white transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-civitas-gold mb-3">Legal & Contact</h4>
            <ul className="space-y-2 text-sm text-civitas-silver">
              {[
                ['/about',    'About Civitas'],
                ['/privacy',  'Privacy Policy'],
                ['/terms',    'Terms of Service'],
                ['/beta-agreement?view=1', 'Participation Agreement'],
                ['/feedback', 'Feedback & Bug Reports'],
              ].map(([to, label]) => (
                <li key={to}><Link to={to} className="hover:text-white transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-white/10 pt-6 text-xs text-civitas-silver flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} BECivitas. All rights reserved. Non-partisan. Non-commercial pilot.</span>
          <span>Built with privacy-by-design. No political data ever leaves your device.</span>
        </div>
        {/*
          Build marker. Renders ONLY when VITE_BUILD_MARKER is set at build
          time; a build that does not set it leaves this element out of the
          tree entirely.

          Why staging needs one. Until 2026-10-11 the staging site emitted no
          marker, which meant nothing could read back what staging was
          serving - not the Control Tower, not a human, not a script. The only
          available evidence was "the last staging run was green", and a green
          deploy proves that bytes were uploaded, not which bytes. An
          environment whose contents cannot be confirmed is an environment you
          cannot test against, and this one exists for nothing else.

          Deliberately identical to main's marker, so one reader works on every
          environment.
        */}
        {import.meta.env.VITE_BUILD_MARKER && (
          <div
            data-testid="build-marker"
            className="mt-4 border-t border-white/10 pt-4 text-xs text-civitas-gold"
          >
            Build marker: {import.meta.env.VITE_BUILD_MARKER}
          </div>
        )}
      </div>
    </footer>
  )
}
